import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'reactstrap';
import { FolderSection, LabelValue } from '../Elements';
import Translate, { t } from '../../common/Translate';
import { useFinal } from '../../../hooks/useCalendar/useRecordBlocs/useFinal';

export const FinalBloc = ({ recordId }) => {
  const {
    isVisible,
    labels,
    goToFinalization,
    isNrmFinalizationActive,
    isCounterAppraisalFinalizationActive,
    downloadDocument,
    hasOffer,
  } = useFinal(recordId);

  return (
    <FolderSection title={t('finalising')} dataTestid="final-bloc" action={goToFinalization} showArrow={isVisible}>
      {isVisible && (
        <>
          {labels.map(({ label, value }) => (
            <LabelValue label={t(label)} value={value} />
          ))}
          {isNrmFinalizationActive && (
            <div className="d-flex align-items-center label">
              <FontAwesomeIcon icon={faBell} color="red" className="mr-1" />
              <span className="text-danger">{t('nrmFinalisation')}</span>
            </div>
          )}
          {isCounterAppraisalFinalizationActive && (
            <div className="d-flex align-items-center label text-danger">
              <FontAwesomeIcon icon={faBell} color="red" className="mr-1" />
              {t('nrmFinalisation2')}
            </div>
          )}
          {hasOffer && (
            <Row className="mt-2">
              <Col xs="8" sm="3" lg="5">
                <Row>
                  <a
                    target="_blank"
                    href={downloadDocument}
                    className="download-btn"
                    rel="noopener noreferrer"
                    id="theHref"
                  >
                    <Translate code="downloadTradeInOfferPdf" />
                  </a>
                </Row>
              </Col>
            </Row>
          )}
        </>
      )}
    </FolderSection>
  );
};

FinalBloc.propTypes = {
  recordId: PropTypes.number.isRequired,
};
